export default "__VITE_ASSET__E6YYDBXC__"